import Checkbox from 'material-ui/Checkbox';
import React from 'react';

export default ({ value, onChange, ...props }) => (
  <Checkbox {...props} checked={value || false} onCheck={(_, isChecked) => onChange(isChecked)} />
);



// WEBPACK FOOTER //
// ./src/components/Checkbox.js